import { render, staticRenderFns } from "./ProfileSalaryList.vue?vue&type=template&id=207e3462"
import script from "./ProfileSalaryList.vue?vue&type=script&lang=js"
export * from "./ProfileSalaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports